const baseUrl = import.meta.env.BASE_URL || "/";

function fromBase(path) {
  const cleanPath = String(path || "").replace(/^\/+/, "");
  return `${baseUrl}${cleanPath}`;
}

export function moduleJsonPath(levelId, moduleNumber) {
  return fromBase(`${levelId}/module${moduleNumber}.json`);
}

export function passagesJsonPath(levelId) {
  return fromBase(`${levelId}/passages.json`);
}

export function assetPath(path) {
  return fromBase(path);
}
